/**
 * Product data access. Today this reads the local JSON file; the function
 * signatures are async on purpose so that swapping to
 *   GET /products         and         GET /products/:id
 * on the backend later requires no changes in any component.
 */
import data from "../data/products.json";

export const CATEGORIES = data.categories;

export async function getProducts(category) {
  return category && category !== "all"
    ? data.products.filter((p) => p.category === category)
    : data.products;
}

export async function getProductById(id) {
  return data.products.find((p) => p.id === id) || null;
}

/* Sync variants, handy for rendering without loading states while the
   data is local. Components use these; the async ones are the API contract. */
export const listProducts = (category) =>
  category && category !== "all" ? data.products.filter((p) => p.category === category) : data.products;
export const findProduct = (id) => data.products.find((p) => p.id === id) || null;
export const categoryLabel = (id) => (data.categories.find((c) => c.id === id) || {}).label || "";
